module.exports = __webpack_public_path__ + "img/Close.86d49f38.svg";